import { getCurrentDevice, loadScript } from './utils';

var styles = [{"featureType": "all", "elementType": "labels", "stylers": [{"visibility": "on"} ] }, {"featureType": "all", "elementType": "labels.text.fill", "stylers": [{"saturation": 36 }, {"color": "#000000"}, {"lightness": 40 } ] }, {"featureType": "all", "elementType": "labels.text.stroke", "stylers": [{"visibility": "on"}, {"color": "#000000"}, {"lightness": 16 } ] }, {"featureType": "all", "elementType": "labels.icon", "stylers": [{"visibility": "off"} ] }, {"featureType": "administrative", "elementType": "geometry.fill", "stylers": [{"color": "#000000"}, {"lightness": 20 } ] }, {"featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{"color": "#000000"}, {"lightness": 17 }, {"weight": 1.2 } ] }, {"featureType": "administrative.country", "elementType": "labels.text.fill", "stylers": [{"color": "#e5c163"} ] }, {"featureType": "administrative.locality", "elementType": "labels.text.fill", "stylers": [{"color": "#c4c4c4"} ] }, {"featureType": "administrative.neighborhood", "elementType": "labels.text.fill", "stylers": [{"color": "#e5c163"} ] }, {"featureType": "landscape", "elementType": "geometry", "stylers": [{"color": "#000000"}, {"lightness": 20 } ] }, {"featureType": "poi", "elementType": "geometry", "stylers": [{"color": "#000000"}, {"lightness": 21 }, {"visibility": "on"} ] }, {"featureType": "poi.business", "elementType": "geometry", "stylers": [{"visibility": "on"} ] }, {"featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{"color": "#a3915c"}, {"lightness": "0"} ] }, {"featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{"visibility": "off"} ] }, {"featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{"color": "#ffffff"} ] }, {"featureType": "road.highway", "elementType": "labels.text.stroke", "stylers": [{"color": "#685c3c"} ] }, {"featureType": "road.arterial", "elementType": "geometry", "stylers": [{"color": "#000000"}, {"lightness": 18 } ] }, {"featureType": "road.arterial", "elementType": "geometry.fill", "stylers": [{"color": "#474642"} ] }, {"featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{"color": "#ffffff"} ] }, {"featureType": "road.arterial", "elementType": "labels.text.stroke", "stylers": [{"color": "#2c2c2c"} ] }, {"featureType": "road.local", "elementType": "geometry", "stylers": [{"color": "#000000"}, {"lightness": 16 } ] }, {"featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{"color": "#999999"} ] }, {"featureType": "transit", "elementType": "geometry", "stylers": [{"color": "#000000"}, {"lightness": 19 } ] }, {"featureType": "water", "elementType": "geometry", "stylers": [{"color": "#000000"}, {"lightness": 17 } ] } ];

var selectedMarker, directionsService, directionsRenderer, bounds;

const initMap = () => {
	document.querySelectorAll('.map').forEach(el => {
		const $map = $(el).find('.map__iframe');
		const mapLat = $map.data('lat') || 0;
		const mapLng = $map.data('lng') || 0;
		const zoom = $map.data('zoom') || 17;

		const $infoboxes = $(el).find('.map__infobox');
		const $btnSearch = $('.js-routes-btn');
		const centerOffsetMobileY = Number($map.data('center-offset-mobile-y')) || 0;
		const centerOffsetMobileX = Number($map.data('center-offset-mobile-x')) || 0;
		const centerOffsetTabletY = Number($map.data('center-offset-tablet-y')) || 0;
		const centerOffsetTabletX = Number($map.data('center-offset-tablet-x')) || 0;

		const center = new google.maps.LatLng(mapLat, mapLng);

		const markers = [];
		let categories = [];

		let selectedInfoWindow;
		let infowindowOffset;

		const bounds = new google.maps.LatLngBounds();

		if (getCurrentDevice() == 'mobile') {
			infowindowOffset = new google.maps.Size(-140, -67);
		} else {
			infowindowOffset = new google.maps.Size(-400, -110);
		}

		// Map Options
		const mapOptions = {
			zoom,
			styles,
			center,
			disableDefaultUI: true,
			markerOptions: {
				icon: 'assets/pin.svg',
			}
		};

		if (!$map.length) return;

		const map = new google.maps.Map($map[0], mapOptions);

		let mode = 'DRIVING';

		$('.js-travel-mode').on('change', function() {
			mode = $(this).val();

			displayRoute($map, map, mode);
		});

		if (getCurrentDevice() === 'mobile' && (centerOffsetMobileY || centerOffsetMobileX)) {
			map.panBy(centerOffsetMobileX, centerOffsetMobileY);
		}

		if (getCurrentDevice() === 'tablet' && (centerOffsetTabletY || centerOffsetTabletX)) {
			map.panBy(centerOffsetTabletX, centerOffsetTabletY);
		}

		// Handle Infobox
		$infoboxes.each((index, el) => {
			const $this = $(el);
			const lat = $this.data('lat');
			const lng = $this.data('lng');
			const pin = $this.data('pin')
			const activePin = $this.data('active-pin');
			const noContent = $this.data('no-content') ? $this.data('no-content') : false;
			const content = $this.html();
			const isMainPin = $this.data('main');
			const category = $this.data('category');
			const id = $this.data('id');

			let icon = {
				url: pin,
			}

			if (isMainPin) {
				icon = {
					size: new google.maps.Size(33, 46),
					scaledSize: new google.maps.Size(33, 46),
					...icon,
				}
			} else {
				icon = {
					size: new google.maps.Size(49, 61),
					scaledSize: new google.maps.Size(49, 61),
					...icon,
				}
			}

			const position = new google.maps.LatLng(lat, lng);

			const marker = new google.maps.Marker({
				position,
				map,
				icon,
				category,
				id,
				pin
			});

			bounds.extend(position);

			if (!isMainPin) {
				markers.push(marker);
			}

			if ( noContent ) {
				return;
			}

			const infowindow = new InfoBox({
				content,
				pixelOffset: infowindowOffset,
				boxClass: 'map__infobox',
				maxWidth: 250,
				alignBottom: false
			});

			// On Marker click
			google.maps.event.addListener(marker, 'click', function() {
				if (selectedInfoWindow != null && selectedInfoWindow.getMap() != null) {
					selectedInfoWindow.close();
				} else if (selectedInfoWindow == infowindow) {
					selectedInfoWindow = null;
				}

				selectedInfoWindow = infowindow;
				selectedInfoWindow.open(map, this);
				// map.setCenter({lat, lng});
				// map.panBy(0, -100);

				resetPins();

				if (!isMainPin) {
					if (activePin) {
						marker.setIcon(activePin);
					}
				}

				$('.map-item').removeClass('active');

				$('#' + marker.id).addClass('active');
			});

			// On Map click
			google.maps.event.addListener(map, 'click', function() {
				infowindow.close();

				$('.map-item').removeClass('active');

				resetPins();
			});
		});

		function resetPins() {
			for (let i = 0; i < markers.length; i++) {
				markers[i].setIcon(markers[i].pin);
			}
		}

		$('.js-map-highlight').on('click', function() {
			const id = $(this).data('marker');
			const marker = markers.filter(marker => marker.id == id)[0];

			new google.maps.event.trigger( marker, 'click' );
		});

		// Handle map filter checkboxes
		$('.js-map-filter').on('click', function() {
			const $this = $(this);
			const category = $this.data('filter');
			const categoryText = $this.text();

			if (category !== '*') {
				$(this).parents('.section-map').find('.map-items__head .h3').text(categoryText);
			} else {
				$(this).parents('.section-map').find('.map-items__head .h3').text('STORES');
			}

			if (selectedInfoWindow) {
				selectedInfoWindow.close();
				resetPins();
			}

			$this.parent().addClass('active').siblings().removeClass('active');

			doFiltration(category);

			map.fitBounds(bounds);

		});

		// Handle map filter checkboxes
		$('.js-map-filter-select').on('change', function() {
			const $this = $(this);
			const category = $this.val();
			const categoryText = $this.text();

			if (category !== '*') {
				$(this).parents('.section-map').find('.map-items__head .h3').text(categoryText);
			} else {
				$(this).parents('.section-map').find('.map-items__head .h3').text('STORES');
			}

			if (selectedInfoWindow) {
				selectedInfoWindow.close();
				resetPins();
			}

			doFiltration(category);

			map.fitBounds(bounds);
		});

		function doFiltration(category) {
			categories = [];

			// Add/remove category for filtering
			if (categories.includes(category)) {
				categories = categories.filter(item => item !== category);
			} else {
				categories.push(category);
			}

			// Filter markers by active category
			const filteredMarkers = markers.filter(marker => categories.includes(marker.category));

			// Hide all markers
			markers.forEach(el => {
				el.setVisible(false);
			});

			// Show only filtered markers
			filteredMarkers.forEach((el) => {
				el.setVisible(true);
			});

			// Show all markers if there is no active filter category
			if(categories.length == 0 || category == '*') {
				markers.forEach(el => {
					el.setVisible(true);
				});
			}
		}
	});

	$('.js-toggle-view').on('click', function() {
		$('.map').toggleClass('list-view');
		$('.js-toggle-view').toggleClass('d-none');
	});
}

export default function mapsUI() {
	loadScript('googleMapURL', window.googleMapURL, function() {
		return loadScript('infoboxScript', window.infoboxScript, function() {
			return new Promise((resolve, reject) => {
				initMap();

				resolve();
			})
		})
	})
}
